/* eslint-disable @typescript-eslint/ban-types */
import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { PlaceFilterComponent } from './code-split/place-filter-component';
import { ModuleProps } from 'src/utils/module-util';

const PlaceFilter: React.FC<ComponentLayoutType<any>> = (props) => {
  const [fiteredData] = React.useState([]);
  interface FilterType extends ComponentLayoutType<any> {
    fiteredItems: any;
    testfunc: (filterdata: Array<{}>) => void;
  }

  // Test usage
  const filterType: FilterType = {
    ...props,
    fiteredItems: fiteredData,
    testfunc: () => {
      // setFiteredData(filterdata);
    },
  };

  return (
    <ComponentLayout {...filterType}>
      <PlaceFilterComponent />
    </ComponentLayout>
  );
};

export default PlaceFilter;

const PlaceFilterModuleV2 = (props: ModuleProps) => {
  const newData = { ...props, ...{ moduleName: 'filter' } };
  return (
    <>
      <PlaceFilter {...newData} />
    </>
  );
};

export { PlaceFilterModuleV2 };
